// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"16def689e50e851d6e61","245":"01666e482e673a572324","452":"259d61c165087d67debe"}[chunkId] + ".js";
};